import axios from 'axios';
import environment from "../config";

export const getFunds = () => {
    return axios.get(environment.BASE_URL + 'General/GetMifneFunds');
}